import { render, staticRenderFns } from "./FormTextInput.vue?vue&type=template&id=b446738c"
import script from "./FormTextInput.vue?vue&type=script&lang=js"
export * from "./FormTextInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports